import { ORDER_ITEM_ACCOUNT_ID_FIELDS, ORDER_ITEM_ROW_ID_FIELDS } from './appsheetVmtMapping';

const normalizeFieldKey = (value) => String(value ?? '').trim().toLowerCase();

export const getCaseInsensitiveValue = (row, fieldName) => {
  if (!row || !fieldName) return undefined;
  if (Object.prototype.hasOwnProperty.call(row, fieldName)) {
    return row[fieldName];
  }
  const target = normalizeFieldKey(fieldName);
  if (!target) return undefined;
  for (const [key, value] of Object.entries(row)) {
    if (normalizeFieldKey(key) === target) {
      return value;
    }
  }
  return undefined;
};

export const getFirstCaseInsensitiveValue = (row, fieldNames = []) => {
  for (const fieldName of fieldNames) {
    const value = getCaseInsensitiveValue(row, fieldName);
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      return value;
    }
  }
  return undefined;
};

export const getOrderItemAccountId = (row) =>
  getFirstCaseInsensitiveValue(row, ORDER_ITEM_ACCOUNT_ID_FIELDS);

export const getOrderItemRowId = (row, fallbackIndex = null) => {
  const explicitRowId = getFirstCaseInsensitiveValue(row, ORDER_ITEM_ROW_ID_FIELDS);
  if (explicitRowId !== undefined && explicitRowId !== null && String(explicitRowId).trim() !== '') {
    return String(explicitRowId);
  }

  const accountId = getOrderItemAccountId(row);
  if (accountId !== undefined && accountId !== null && String(accountId).trim() !== '') {
    return fallbackIndex === null ? String(accountId) : `${String(accountId)}-${fallbackIndex}`;
  }

  return fallbackIndex === null ? '' : `row-${fallbackIndex}`;
};

export const normalizeBoolean = (value) => {
  if (value === null || value === undefined) return null;
  if (typeof value === 'boolean') return value;
  const normalized = String(value).trim().toLowerCase();
  if (!normalized) return null;
  if (['y', 'yes', 'true', '1'].includes(normalized)) return true;
  if (['n', 'no', 'false', '0'].includes(normalized)) return false;
  return null;
};

export const toDisplayValue = (value, fallback = 'N/A') => {
  if (value === null || value === undefined) return fallback;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed ? trimmed : fallback;
  }
  return String(value);
};
